import React from 'react'

function About() {
  return (
	<>
	{/* <section className="dark:bg-gray-800 dark:text-gray-100">
	<div className="container mx-auto space-y-12">
		<div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row">
			<img src="https://source.unsplash.com/640x480/?1" alt="" className="h-80 dark:bg-gray-500 aspect-video" />
			<div className="flex flex-col justify-center  p-6 dark:bg-gray-900">
				<span className="text-xs uppercase dark:text-gray-400">Join, it's free</span>
				<h3 className="text-3xl font-bold">Build modern website</h3>
				<p className="my-6 dark:text-gray-400">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor aliquam possimus quas, error esse quos.</p>
				<button type="button" className="self-start">Action</button>
			</div>
		</div>
		<div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row-reverse">
			<img src="https://source.unsplash.com/640x480/?2" alt="" className="h-80 dark:bg-gray-500 aspect-video" />
			<div className="flex flex-col justify-center  p-6 dark:bg-gray-900">
				<span className="text-xs uppercase dark:text-gray-400">Join, it's free</span>
				<h3 className="text-3xl font-bold">AIGC、ChatGPT consultant</h3>
				<p className="my-6 dark:text-gray-400">Help individuals or businesses apply various AI tools and ChatGPT to their daily, learning, and work processes.</p>
				<button type="button" className="self-start">Action</button>
			</div>
		</div>
		<div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row">
			<img src="https://source.unsplash.com/640x480/?3" alt="" className="h-80 dark:bg-gray-500 aspect-video" />
			<div className="flex flex-col justify-center  p-6 dark:bg-gray-900">
				<span className="text-xs uppercase dark:text-gray-400">Join, it's free</span>
				<h3 className="text-3xl font-bold">Build LLMs product</h3>
				<p className="my-6 dark:text-gray-400">Develop various LLM applications, from text to images, voice, and vector databases.</p>
				<button type="button" className="self-start">Action</button>
			</div>
		</div>
	</div>
</section> */}



<section className="dark:bg-gray-800 dark:text-gray-100">
	<div className="container max-w-xl p-6 py-12  space-y-24 lg:px-8 lg:max-w-7xl">
		<div>
			<h2 className="text-3xl font-bold tracki  sm:text-5xl dark:text-gray-50">About me</h2>
			<p className="max-w-5xl  mt-4 text-md  dark:text-gray-400">I'm Jimmy, with over 4 years + of software development experience, primarily focusing on web projects. I enjoy the process of taking projects from conception to completion, relishing in the design and development journey from ground zero. I've participated in various scales of hackathons and undertaken numerous side projects. I've collaborated with people from around the world, often taking on roles as a project manager, working on both frontend and backend development, and engaging in AI and infrastructure tasks within projects.

Through these experiences, I've accumulated skills in product management, market analysis, development processes, and data analysis. These experiences have given me a deep understanding of the challenges various roles face, enabling me to effectively communicate across disciplines.




</p>
<p className="max-w-5xl  mt-4 text-md  dark:text-gray-400">Recently, I've been deeply captivated by generative AI, exploring a wide array of projects involving large language models, image generation, sound synthesis, and more. I've engaged in numerous projects, authored several articles, and undertaken multiple side projects in this field. In addition, I've founded HomerAI, a platform dedicated to teaching the techniques of using ChatGPT and applying AI tools effectively.

If you're also intrigued or have any questions about generative AI, I'd be more than happy to have a conversation with you. Feel free to reach out and let's discuss!</p>

		</div>
	</div>
</section>
	</>
	
  )
}

export default About